import { NavItem } from './nav-item/nav-item';
import { MODULOS } from './modulos';

/**
 * Menú completo (todos los módulos, cada uno con su título). El lateral ya no lo usa: muestra
 * solo el módulo activo (ModuloService.navItems). Se conserva para el layout horizontal.
 */
export const navItems: NavItem[] = MODULOS.flatMap((m) => [{ navCap: m.nombre } as NavItem, ...m.items]);

/**
 * Páginas de la plantilla Matdash fuera del menú (las rutas siguen activas).
 * Para volver a mostrarlas, mover estas entradas a `navItems`.
 */
export const navItemsOcultos: NavItem[] = [
  {
    displayName: 'Dashboard 1',
    iconName: 'solar:widget-add-line-duotone',
    route: '/dashboards/dashboard1',
  },
  {
    displayName: 'Dashboard 2',
    iconName: 'solar:chart-line-duotone',
    route: '/dashboards/dashboard2',
  },
  {
    displayName: 'Dashboard 3',
    iconName: 'solar:screencast-2-line-duotone',
    route: '/dashboards/dashboard3',
  },
  {
    displayName: 'Calendar',
    iconName: 'solar:calendar-mark-line-duotone',
    route: 'apps/calendar',
  },
];
